module.exports = __webpack_public_path__ + "public/images/btn-file.877ab6c16029685e1fe0a77503494c8d.svg";